import styles from './select.module.scss';
import {classNames} from '../../support/classnames.ts';
import {useCallback, useState} from 'react';

export interface SimpleSelectOption {
    label: string;
    value: string | number;
}

interface OwnProps {
    name?: string;
    value?: string | number | null;
    defaultValue?: string | number | null;
    onChange?: (value: string) => void;
    options: SimpleSelectOption[];
    emptyLabel?: string;
    isLocked?: boolean;
    isDisabled?: boolean;
    useHiddenInput?: boolean;
}

export function SimpleSelect(props: OwnProps) {
    const [value, setValue] = useState<string | number | undefined>(props.defaultValue || undefined);
    const {onChange} = props;
    const onChangeHandler = useCallback(
        (value: string) => {
            onChange && onChange(value);
            setValue(value);
        },
        [onChange],
    );

    return (
        <div
            className={classNames(styles.simple_select, {
                [styles.locked]: props.isLocked,
            })}
        >
            <select
                disabled={props.isDisabled}
                name={props.name}
                value={props.value ?? value ?? ''}
                onChange={(option) => onChangeHandler(option.target.value)}
            >
                {props.emptyLabel ? <option value="">{props.emptyLabel}</option> : null}
                {props.options.map((option) => {
                    return (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    );
                })}
            </select>
            <i className="fa-light fa-chevron-down" />
            {props.useHiddenInput && props.name && <input type="hidden" name={props.name} value={value} />}
        </div>
    );
}
